const ROUTE = {
  LOGIN: '/',
  RESETPASSWORD: '/mot-de-passe-oublie',
  REDIRECTIONMAIL: '/redirection-mail',
  REINTIALISATIONMDP: '/reinitialisation-mdp',
  VALIDATIONMODIFICATIONMDP: '/validation-changement-mdp',
  DASHBOARD: '/dashboard',
  CONTRATS: '/contrats',
  OPERATIONS: '/operations',
  INFORMATIONS: '/informations',
  PARRAINAGE: '/parrainage',
  INVESTIR: '/investir',
  HELP: '/aide',

  ACCESPARTENAIRES: '/acces-partenaires',
  AUTRESACCES: '/autres-acces',

  SELECTCONTRACT: '/operations/choisir-un-contrat',
  SELECTOPERATION: '/operations/faire-operation',

  RAPPELCONSEILLER: '/aide/rappel-conseiller',
  VALIDATIONRAPPELCONSEILLER: '/aide/validation-rappeler',

  ASSURANCEVIE: '/contrats/assurance-vie/:id',
  DEFISCALISATION: '/contrats/defiscalisation/:id',
  IMMOBILIER: '/contrats/immobilier/:id',
  RETRAITE: '/contrats/retraite/:id',
  LIVRET: '/contrats/livret-epargne/:id',

  DEPOSIT: '/contrats/:familleContrat/:typeContrat/faire-versement',
  FAIREVERSEMENTJUSTIFICATIFS: '/contrats/:familleContrat/:typeContrat/faire-versement/justificatifs',
  FAIREVERSEMENTVALIDATION: '/contrats/:familleContrat/:typeContrat/faire-versement/validation',
  FAIREVERSEMENTSIGNATURE: '/contrats/:familleContrat/:typeContrat/faire-versement/signature',
  FAIREVERSEMENTSUCCES: '/contrats/faire-versement/',
  FAIREVERSEMENTCANCEL: '/contrats/faire-versement/annulation',
  FAIREVERSEMENTFAIL: '/contrats/faire-versement/erreur-inconnue',
  FAIREVERSEMENTERROR: '/contrats/faire-versement/erreur',

  ARBITRAGESUMMARY: '/operations/arbitrages/:id/recapitulatif',
  ARBITRAGEJUSTIFICATIFS: '/operations/arbitrages/:id/justificatifs',
  ARBITRAGESIGNATURE: '/operations/arbitrages/:id/signature',
  ARBITRAGESIGNATURESUCCESS: '/operations/arbitrages/signature/succes',
  ARBITRAGESIGNATUREERROR: '/operations/arbitrages/signature/erreur',
  ARBITRAGESIGNATUREREFUSAL: '/operations/arbitrages/signature/refus',

  SSOCONSEILLER: '/ssoconseiller/:token',
  AUTH0CALLBACK: '/callback',

  ERREUR: '/erreur',
  NOTFOUND: '*',
};

const DEMO_ALLOWED_ROUTES = [
  ROUTE.DASHBOARD,
  ROUTE.CONTRATS,
  ROUTE.ASSURANCEVIE,
  ROUTE.DEFISCALISATION,
  ROUTE.IMMOBILIER,
  ROUTE.RETRAITE,
  ROUTE.LIVRET,
  ROUTE.AUTRESACCES,
] as const;

export { DEMO_ALLOWED_ROUTES, ROUTE };
